// React things
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Rive things
import {
  useRive,
  Layout,
  Fit,
  Alignment,
  EventType,
} from "@rive-app/react-canvas";

// Stores
import useApplicationSettings from "../../Store/ApplicationSettings.js";
import useSourceStore from "../../Store/SourceStore.js";

// Components
import RiveArtboard from "../../ComponentsWrappers/RiveArtboard.jsx";

export default function RewardTypeFilter(props) {
  const navigate = useNavigate();

  const riveComponent = useSourceStore((state) => state.riveComponent);

  const setLeaderBoardRewardType = useApplicationSettings(
    (state) => state.setLeaderBoardRewardType
  );
  const localization = useApplicationSettings((state) => state.localization);

  const { rive, RiveComponent } = useRive({
    src: riveComponent ? riveComponent : null,
    artboard: localization["rive_TypeFilter 2"],
    stateMachines: "State Machine 1",
    autoplay: true,
    layout: new Layout({
      fit: Fit.FitWidth, // Change to: rive.Fit.Contain, or Cover
      alignment: Alignment.Center,
    }),
  });

  useEffect(() => {
    if (rive) {
      props.setLoading(false);
      rive.on(EventType.RiveEvent, (e) => {
        const tg = window.Telegram.WebApp;
        switch (e.data.name) {
          case "EarnedClick":
            setLeaderBoardRewardType("earned");
            break;
          case "FarmedClick":
            setLeaderBoardRewardType("farmed");
            break;
        }
      });
    }
  }, [rive]);

  return <RiveComponent />;
}
